'use client'
import './TemplateCard.scss'
import {useEffect, useState} from "react";
import ImageWithFallback from "../img/ImageWithFallBack";

type templateCardType = {
    labels: string[];
    preview: string;
    title: string;
    active?: boolean;
    createdAt?: number;
    thumbnail:string;
    t: (s: string) => string
    imageBaseUrl: string;
    clientName: string,
    isSkeleton?: boolean
};

export function TemplateCard({thumbnail, preview, title, active = false, createdAt, t, imageBaseUrl, clientName, isSkeleton = false}: templateCardType) {

    const [skeletonThumbnail, setSkeletonThumbnail] = useState<string>()

    useEffect(() => {
        console.log(thumbnail);
        if (thumbnail) {
            if (isSkeleton) {
                setSkeletonThumbnail(`${imageBaseUrl}/${clientName}/skeletons/${thumbnail}`)
            } else {
                setSkeletonThumbnail(`${imageBaseUrl}/uploads/${thumbnail}`)
            }
        }
    }, [thumbnail]);

    let diffInDays:number | null = null
    if (createdAt) {
        const createdDate = new Date(createdAt * 1000);
        const currentDate = new Date();
        const diffInTime = currentDate.getTime() - createdDate.getTime();
        diffInDays = diffInTime / (1000 * 3600 * 24);
    }
    const isNew = diffInDays ?  diffInDays <= 30 : false;

    return (
        <div key={title} className={`card ${active ? 'is-active is-active-check' : ''}`} style={{display: "block"}}>
            <ImageWithFallback width={200} height={200} src={skeletonThumbnail ? skeletonThumbnail : ''} alt={title} />
            {preview}
            {/*{labels.length > 0 && <div className="card-labels">*/}
            {/*    <div className="card-label">{labels[0].substring(0, 15)}{labels[0].length > 15 ? '...' : ''}</div>*/}
            {/*    {labels.length > 1 && <div className="card-label-more">+{labels.length - 1}</div>}*/}
            {/*</div>}*/}
            <div className="card-body">
                {isNew && <div className="card-new">{t('NEW')}</div>}
                <div className="card-title">{title}</div>
            </div>
        </div>
    );
}
